import DataGridComponent from "../../components/tables/DataGrid";
import BreadCrumb from "../../components/BreadCrumb/BreadCrumb";
import { dataColumnsVB } from "../../hooks/fundAccounting";
import useDataGrid from "../../hooks/useDataGrid";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { deleteFundAccounting, getAllFundAccountingsVB } from "../../redux/slices/fundAccounting";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";

export default function VBList() {
  const dispatch = useDispatch();
  const { fundAccounting } = useSelector((state) => state.fundAccounting);
  const navigate = useNavigate();

  const handleDelete = async (id) => {
    const response = await dispatch(deleteFundAccounting(id));
    return response;
  };

  useEffect(() => {
    dispatch(getAllFundAccountingsVB());
  }, [dispatch]);


  const [column] = useDataGrid(dataColumnsVB, handleDelete, "", false);

  return (
    <div>
      <div className="flex justify-between my-2 items-center bg-[#2b2c84]/20 px-5 py-2 rounded">
        <div>
          <h1 className="font-semibold text-[#1E293B] text-2xl">Rendicion Visto Bueno</h1>
          <BreadCrumb origin={"Rendicion de gastos"} current={"Rendicion VB"} />
        </div>
      </div>
      <DataGridComponent
        columns={column}
        rows={[...fundAccounting].sort((a, b) => {
          return new Date(b.date) - new Date(a.date);
        })}
        success={true}
      />
    </div>
  );
}
